import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { HistoryEntry } from '../../models'
import { StatusBadgeComponent } from '../status-badge/status-badge.component'

@Component({
    selector: 'ach-transaction-history',
    standalone: true,
    imports: [DatePipe, StatusBadgeComponent],
    templateUrl: './transaction-history.component.html',
    styleUrl: './transaction-history.component.scss',
})
export class TransactionHistoryComponent {
    @Input({ required: true }) history: HistoryEntry[] = []

    get sortedHistory(): HistoryEntry[] {
        return [...this.history].sort((a, b) =>
            new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()
        )
    }
}
